module.exports = __webpack_public_path__ + "img/receipt9.d2c97114.png";